var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"hide-footer":"","title":"Movimiento de deposito","size":"lg","id":"filter-history"}},[_c('view-component',{attrs:{"model_name":"filter_history","change_from_dates_option":"","check_permissions":false,"show_btn_save":false,"show_btn_delete":false,"show_previus_days":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }